import { Flex, Text } from '@pancakeswap/uikit'
import { useTranslation } from 'contexts/Localization'
import { DeserializedPool } from 'state/types'
import BigNumber from 'bignumber.js'

interface AprRowProps {
  pool: DeserializedPool
  stakedBalance: BigNumber
  performanceFee?: number
  discountRatePercent?: string
  discountSave: BigNumber
  busdPrice: Number
}

const AprRow: React.FC<AprRowProps> = ({ pool }) => {
  const { t } = useTranslation()
  const { stakingToken, remainingSwaps } = pool

  return (
    <>
      <Flex alignItems="center" justifyContent="space-between">
        <Text>{`${t('Price:')}`}</Text>
        <Text>
          {`2 `}
          {stakingToken.name}
        </Text>
      </Flex>
      <Flex alignItems="center" justifyContent="space-between">
        <Text>{`${t('Swaps Left:')}`}</Text>
        <Text>{`${remainingSwaps} of 100`}</Text>
      </Flex>
    </>
  )
}

export default AprRow
